import React from "react";
import {
  Col, Container, Row
} from "reactstrap";

import Section from "./Section";

import VesselForm from "./AddVesselDetails";

const JobDetails = () => {
  document.title = 'Vesesl Details | StarMarket';
  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container>
          <Row>
            <VesselForm />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default JobDetails;
